import { RULEMANAGER_API } from '~/lib/constants';

export function getApiPath(profile: string, path: string): string {
  // return `https://selfserve-edge.serverless.p2g.systems/${SettingsCache.profile}`;
  return `${RULEMANAGER_API}/${profile}${path}`;
}
